import {AnimatePresence, motion} from "framer-motion";

export default function PillBadge({ item, onClick }) {
    return (
        <AnimatePresence>
            <motion.span
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -5 }}
                transition={{ bounce: 0, duration: 0.2 }}
                className="flex items-center rounded-full bg-green-100 text-white pb-1 pt-1.5 px-3 text-xs font-bold"
            >
                {item}
                <button
                    type="button"
                    className="ml-2 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-indigo-400 hover:bg-beige-200/30 whitespace-nowrap"
                    data-item={item}
                    onClick={onClick}
                >
                    <span className="sr-only">Remove {item} option</span>
                    <svg className="h-2 w-2 pointer-events-none" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                        <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
                    </svg>
                </button>
            </motion.span>
        </AnimatePresence>
    )
}